import achieve_1 from "./Images/home/home_sliders/achieve_1.webp";
import educate_1 from "./Images/home/home_sliders/educate_1.webp";
import enable_1 from "./Images/home/home_sliders/enable_1.webp";
import engage_1 from "./Images/home/home_sliders/engage_1.webp";
import grow_1 from "./Images/home/home_sliders/grow_1.webp";
import inspire_1 from "./Images/home/home_sliders/inspire_1.webp";
import team1 from "./Images/home/team/team (1).png";
import team2 from "./Images/home/team/team (2).png";
import team3 from "./Images/home/team/team (3).png";
import team4 from "./Images/home/team/team (4).png";

export const slider_images = [
  educate_1,
  inspire_1,
  enable_1,
  achieve_1,
  engage_1,
  grow_1,
];

export const menuItems = [
  {
    title: "Home",
    path: "/",
    // icon: Home,
    hasDropdown: false,
  },
  {
    title: "About Us",
    path: "/about",
    hasDropdown: false,
  },
  {
    title: "Campaigns",
    hasDropdown: true,
    dropdown: [],
    path: "/campaigns",
  },
  {
    title: "Our Work",
    hasDropdown: true,
    dropdown: [],
    path: "/services",
  },

  {
    title: "Get Involved",
    path: "/get-involved",
    hasDropdown: false,
  },
  {
    title: "Our Team",
    path: "/our-team",
    hasDropdown: false,
  },
  {
    title: "Our Support Partner",
    path: "/our-support-partner",
    hasDropdown: false,
  },
  {
    title: "Gallery",
    path: "/gallery",
    hasDropdown: false,
  },
  {
    title: "Blogs",
    path: "/blogs",
    hasDropdown: false,
  },
  {
    title: "Contact",
    path: "/contact",
    hasDropdown: false,
  },
];
export const contact_details = {
  mobile: "+91 9090969619",
  email: "directorpr@afsa.in",
  // email: "coo@afsa.org.in",
  address:
    "Plot No- 686/2882, Shanti Nagar, Canal Road, Jharpada, Bhubaneswar, Odisha - 751006",
};

export const teamMembers = [
  {
    name: "Ananya Mohanty",
    role: "Saree Designer",
    image: team3,
  },
  {
    name: "Raghunath Patnaik",
    role: "Handloom Expert",
    image: team1,
  },
  {
    name: "Lipika Das",
    role: "Marketing & Sales Head",
    image: team4,
  },
  {
    name: "Bijay Rout",
    role: "Cultural Curator & Craft Specialist",
    image: team2,
  },
];

// export const certificates = [
//   {
//     desc: `Dr. Alexxzandar Dass, Chairman, KGI conferred with "Most Inspiring Educationist" Award`,
//     img: award2,
//   },
//   {
//     desc: "Founder of AAFSA Dr. Alexzandar Das received the Sustainability Global Changemaker Award in Dubai",
//     img: award1,
//   },
//   {
//     desc: `Awarded as the "Outstanding & Trusted Group of Institutions in India" in Bangalore`,

//     img: award4,
//   },
//   {
//     img: award3,
//     desc: "KGI has been honored as the Best Group of Institutions for Holistic Development.",
//   },
// ];


// export const services = [
//   {
//     id: "68959a61a0d8c786800e4659",
//     title: "Education and Skill Development",
//     bgColor: "#D3EDFF",
//     icon: education_icon,
//     description: [
//       {
//         heading: "Digital literacy-",
//         content:
//           "Govt. of India’s ‘National Digital Literacy Mission’ (NDLM) scheme is to provide digital literacy to every Indian. Making one person in every family digitally literate is one of the integral components of the Prime Minister’s vision of “Digital India”.\n\nOur unique training module stands on 3 verticals i.e Digital literacy, financial literacy each session duration 10 hours and the Digital Empowerment which session duration is 20 hours in three languages Odia, Hindi and English. We cover rural youth, students, AWWs, WSHG members and cluster business units supported by MSME Departments. This program envisages enabling people to actively and effectively participate in the democratic and developmental process and enhance their livelihood.After training all candidates assessed on line by CSC and awarded with certificates.",
//       },
//       {
//         heading: "Quality Education-",
//         content:
//           "Provide quality education to bridge gaps in both urban slums and rural areas for unprivileged and marginal children by supporting remedial teachers. Teaching learning Aids to visually impaired students. Provides scholarship to merit students in school and colleges.",
//       },
//       {
//         heading: "Skill Training-",
//         content:
//           "AAFSA conducted skill mapping exercises in different operational area to upgrade their existing skill and introduced new skill. Trainees are also getting all type of support and services to set up their business unit. No of youth trained on ………. trades.",
//       },
//       {
//         heading: "Inclusive Education-",
//         content:
//           "AAFSA defines “child labour” that any children age below 14 years not going to school is under child labour. Organization strategies are to ensure all children below 14 years access to school and regular attending school. Improve quality and relevance of education. Minimize violence in school and zero dropouts. AAFSA has formed and strengthens parents- teachers association (PTA) and ensures the regularity of the students. Balpanchayats are formed where student discuss their problems and solve them with the support of PTA. They also motivate dropouts to join school. Organization organizes sensitization meeting for teachers to follow joyful learning and initiate extracurricular activities to attract children. Drop out students have linked to bridge courses. AAFSA has been striving to provide best possible effort to poorest talent students in their operational area. Current year organization takes a new initiative that encourages teachers to use mother tongue at least up to third standard for quick grasping of students specially in tribal pockets. However, its endeavour is constrained by limited financial resources. The response of host communities to these initiatives has been overwhelmingly positive.",
//       },
//     ],
//     images: [
//       "https://res.cloudinary.com/dqxlte6wf/image/upload/v1754889328/tbcrkfe3zjcv9md3cowy.png",
//     ],
//   },
//   {
//     id: "68959946a0d8c786800e4536",
//     title: "Health and Wellness",
//     bgColor: "#FFEED6",
//     icon: wellness_icon,
//     description: [
//       {
//         heading: "Preventive",
//         content:
//           "AAFSA has organised several Trainings & Campaigns with the technical support of local hospitals. The trainings programmes were organised differently for School & College Children, Women, Aged, Working Professionals at different places of Jajpur, Cuttack and Khurda Districts of Orissa. Nearly 1000 participants had attended programs organised across odisha. Motivated children demonstrate best hygienic practices and good health behaviour encourages their parents to follow the same.As malaria is endemic in many areas of the state, AAFSA takes initiatives measures against this disease.Ensure mosquito nets distribution with the support of health committees, chlorinate wells and advertise government treatment programmes. Public awareness disseminates on Malaria, TB and HIV/AIDS and special campaigns are organised for high-risk group (HRG) to prevent HIV/AIDS.",
//       },
//       {
//         heading: "Curative:",
//         content:
//           "We provide financial assistance to most deprived (12 patients) for their expensive treatment of critical diseases. In order to ensure that communities can access government health services, we organize interface meet between village health committee and local health service providers to reflect their issues and its solution to resolve. in current year, AAFSA organizes 03 blood donation camps with the support of staff from the village primary health centre in remote regions and gathering over 250 units of blood. This campaign now turned into a movement mode.At this point local youth appeal, us to scale our camps where they can donate blood for the needy. AAFSA also facilitates government health programs for immunization through the Pulse Polio campaign. Health Committees in villages also push government officials to provide regularbasichealthservices. Field staff of AAFSA assists health service providers at community on referral to nearest PHC, CHC, DHH. AAFSA organizes health camps and free medicine distribution with the support of local doctors at community and schools for immediate treatment and diagnose at doorsteps and further referral. This year more than 300 patients received free diagnosis services and medicines.\n\nTo address the nutritional deficiency, we organise series of awareness meeting with nutrition experts and promote kitchen garden interventions with the technical support of local agricultural experts.",
//       },
//     ],
//     images: [
//       "https://res.cloudinary.com/dqxlte6wf/image/upload/v1754889296/jwb5zi6ele13zt913xp4.png",
//     ],
//   },
//   {
//     id: "68931d7821493c5d6d8182d5",
//     title: "Climate Change Action",
//     bgColor: "#C3FFFF",
//     icon: climate_icon,
//     description: [
//       {
//         heading: "Service for Climate Change Action:",
//         content:
//           "AAFSA initially starts its work in the district of Jajpur which is a heat prone area because of rapid industrial growth and massive deforestation. Near about more than 250 small, medium and large-scale industries are set up. Excessive heat, Air and Water pollution are major issues that affects day-to-day life of community. Community suffering on those issues instigate AAFSA to take some small initiatives against climate change. We realise climate change is a global phenomenon but it is people and communities at the local level that experiences its consequences. In this particular district, we experienced rain deficit monsoon, unseasonal rains have disturbed the crop- cycles that compel farmers to migrate. It is a global issues and whole country badly affected. More than 80% of the Indian population lives in the districts highly vulnerable to extreme weather events. India may lose anywhere around 3-10% of its GDP annually by 2100 and its poverty rate may rise by 3.5% in 2040 due to climate change. India has the world’s highest social cost of carbon. Taking all those concerns in mind AAFSA starts some micro initiatives and will try to scale up all our efforts in partnership with different like-minded organizations.\n\nWe actively promote climate awareness educates communities about climate change to foster knowledge and proactive engagement. We are also organizing campaign to empower youth in higher secondary schools and technical colleges for climate action. In engineering colleges, we propagate green building concept and technology specially with Civil stream. Few students are also trained on green auditing. To promote clean energy we distributed solar home lamps where electricity supply frequently disrupted . Engaging stakeholders from media, academia, Civil Society organizations and policy makers to drive climate action. This year we have undertaken massive community plantation and avenue plantation (approximate 5000 plants) at strategic location by organizing work camps of local youth.\n\nAAFSA promotes climateresistance crops to increase the yield. Argo clinics are also set up to provide technical support and services to farmers group at ground.",
//       },
//     ],
//     images: [
//       "https://res.cloudinary.com/dqxlte6wf/image/upload/v1754889103/m5oaa2hosiggbh3krnsa.png",
//     ],
//   },
//   {
//     id: "68932df921493c5d6d8191db",
//     title: "Women Empowerment",
//     bgColor: "#FFDAD6",
//     icon: women_empowerment_icon,
//     description: [
//       {
//         heading: "Services for Women Empowerment",
//         content:
//           "Working with women folks our realised experiences encourage us to focus women’s sense of self -worth, their right to determine choices, right to access to opportunities and resources, right to have power to control their own lives both within and outside the home and their ability to influence the direction of social change. Our community-based vigilance committees put their effort to achieve gender equality through equal access to various types of opportunities related to health care, education, domestic work and daily labourers. We are organising awareness campaigns specially for women mason and construction sector women labour force. Sensitization meeting with contractors/builders to ensure equal pay for equal work and for provision of other additional facilities at work site. AAFSA strongly believed that the education is one the most important means of empowering women with knowledge, skill and self -confidence necessary to participate fully in the development process. From poor economic back groundapproximately 30 nos of girls’ students received financial assistance for their further higher study. Many merit students are also getting scholarship to continue their study without depending on their family. To keep the thought inclusive development, we formed and strengthen more than 300 women self-help group. Bank linkage and financial literacy training provides to all WSHGs. With an objective of devolution of powers in practice, we sensitised PRI members in our operational area where significant numbers of women leaders are sensitised and play crucial role for their local area development. Our small efforts impacting locality as girl students drop out rates reduces, increased the no of girl students continue their higher studies, WSHG members are accessing Govt resources and starts their own business and Panchayat body heard the voice of women leaders. Our management team also encourages, influence and advocate before local Govt to ensure the gender focused budget and gender friendly execution of all Govt schemes. Every year AAFSA observe the international women empowerment day where women who works for the mission, received award for their exceptional work.",
//       },
//     ],
//     images: [
//       "https://res.cloudinary.com/dqxlte6wf/image/upload/v1754889127/fdzu6j9shsn5sqexyyct.png",
//     ],
//   },
//   {
//     id: "68948292a7fd9d4db6646903",
//     title: "Livelihood & Entrepreneurship",
//     bgColor: "#D8E5FF",
//     icon: livilihood_icon,
//     description: [
//       {
//         heading: "Cluster business approach:",
//         content:
//           "Stone carving cluster – Mega cluster approach is a Drive to scale up the infrastructural and production chain at stone carving clusters which have remained unorganized and have not kept pace with the modernization and development that have been taking place so far. Consequently, there has not been any addition of fresh impetus of development and optimum realization of output in the stone carving business, which is not only the backbone of long traditional heritage and cultural linkages.\n\nDress designing cluster – The prospects of this sector lie in infrastructural up gradation, modernization of the machinery and product diversification. Innovative manufacturing as well as designing expertise, furthered by brand building of the native products hold the key to creating a niche market for the products manufactured by the clusters. The objective of this program is to support for up gradation of infrastructural facilities coupled with market linkages and product diversification. Keeping in view the fact that the export value realization of products is quite high, integrated infrastructure development has been the policy focus in recent times. The multiplicity in production in tiny units along with geographical wide spread base has resulted into higher level of levies marring the competitiveness in international market. Thus, addressing the problem of infrastructure bottlenecks by suggesting continuation of the sector specific infrastructure schemes has been the focus of attention. Technology Up gradation, Product Diversification, Raw Material Bank, Common Facility centre (CFC), Resource centre, Market Development such as Forward & Backward Linkages, Human Resource & Skill Development, Social Security, Physical Infrastructure are facilitated by AAFSA.\n\nAAFSA focuses on empowering the tribal as well as the non-tribal falls under below poverty line enabling them to enhance their food security, increase their incomes and improve their overall quality of life through natural resource based on the principles of improved watershed management with environmentally sound agricultural practices through off-farm/non-farm enterprise development.",
//       },
//     ],
//     images: [
//       "https://res.cloudinary.com/dqxlte6wf/image/upload/v1754889252/ouu0ohypmewvvig8yteo.png",
//     ],
//   },
// {
//   id: "689593aba0d8c786800e41bb",
//   title: "Wash Plush",
//   bgColor: "#CEFFC3",
//   icon: wash_plus_icon,
//   description: [
//     {
//       heading: "Cross cutting issue-based Interventions:",
//       content:
//         "Community Based Disaster Preparedness CBDP: Support to NGOs for contingency plan.\n\nOurexperienced staff given technical guidance to CBOs and other NGOS of our network in preparing contingency plan in the costal belt of Odisha. The objective of this plan is to make awarethe community about risk factors and strategy to minimiselosses during disaster. Explore the community-based knowledge, information, skill and use them in different form that helps community to minimise lossesandmake them prepared to cope up of the post disaster situation.",
//     },
//     {
//       heading: "Forest and Environment: Plantation.",
//       content:
//         "AAFSA observes “Banamahotshab”and undertakes plantation programs. Organization encourages forest fringe community to follow echo-harvesting methods for collection of non-timber forest products to protect the forest. Promote forest protection committees to sustain the village forests. Play a vital role in coordination among community, VSS, PRI and forest department officials.",
//     },
//     {
//       heading: "Governance: PRI Training. Micro planning.",
//       content:
//         "AAFSA believes on the thought that unless devolution of power of PRI put in practice, socio economic development of rural people will not be possible. Organisation imparts series of sensitization training to empower PRIs. The effect of our empowerment process is significant number of women leaders come forward and contest in Panchayat elections. People attendances increased in Gram sabha and Palli sabha. AAFSA assists panchayat to facilitate micro plan with maximum participation of villagers where people make their plan with propose budget according to their prioritize needs. Provides technical assistance to GPs by ensuring participation of govt department’s staff and make the micro plan more effective.",
//     },
//     {
//       heading: "Consulting Services.",
//       content:
//         "In considering the need and demand of local NGOs, AFSA has established one consulting cell where some regular and part time experienced consultants are providing consulting services to local NGOs. The key services are digital identity across glob, fund raising initiatives, consortium proposal writing, program strategy development; innovative model development, monitoring and evaluation, research and documentation of best practices and capacity building of work force",
//     },
//     {
//       heading: "Our Partners.",
//       content:
//         "Kalinga Group of Institutions (KGI)\nSiksha Trust in partnership with MSME Dept Govt of India.\nDibyang Adarsha Trust",
//     },
//   ],
//   images: [
//     "https://res.cloudinary.com/dqxlte6wf/image/upload/v1754889272/aq6c7mtwpphkgics3ubu.png",
//   ],
// },
// ];


